import { jsx as _jsx } from "react/jsx-runtime";
import { PasskeyIcon } from "../../../icons/passkey.js";
import { ls } from "../../../strings.js";
import { Button } from "../../button.js";
import { usePasskeyVerify } from "../hooks/usePasskeyVerify.js";
// Not used externally
// eslint-disable-next-line jsdoc/require-jsdoc
export const PasskeyAuth = ({ label = ls.login.passkey.button }) => {
    const { authenticate } = usePasskeyVerify();
    return (_jsx(Button, { variant: "social", icon: _jsx(PasskeyIcon, {}), onClick: authenticate, children: label }));
};
//# sourceMappingURL=PasskeyAuth.js.map